import { Pick } from "model/Pickem/Pickem";
import {
  BracketSegment,
  getBracketMatchIds,
} from "model/Tournament/Segment/Bracket/Bracket";
import { PickersContainer } from "../styles";
import { BracketemBracketPicker } from "./BracketemBracketPicker";
import { FlexColumn } from "styles/layout";
import { BracketGraph, getAllNodes } from "model/Bracket/BracketGraph";
import { onlyUnique } from "Utility";

interface Props {
  segment: BracketSegment;
  tournamentId: string;
  groupId: string | undefined;
  picks: {
    [id: string]: Pick;
  };
  updatePicks: (newPicks: { id: string; pick: Pick }[]) => void;
}

export const BracketemPicker = ({
  segment,
  tournamentId,
  groupId,
  picks,
  updatePicks,
}: Props) => {
  const updatePick = (matchId: string, rosterId: string | undefined) => {
    const matchIdsToClear = getFutureMatchIds(matchId, segment);
    const newPicks = [
      { id: matchId, pick: rosterId },
      ...matchIdsToClear.map((id) => ({
        id,
        pick: undefined,
      })),
    ];

    updatePicks(newPicks);
  };

  return (
    <FlexColumn>
      {segment.groups
        .filter((g) => !groupId || g.groupId === groupId)
        .map((g) => (
          <>
            <PickersContainer>
              <BracketemBracketPicker
                bracket={g}
                picks={picks}
                updatePick={updatePick}
                tournamentId={tournamentId}
              />
            </PickersContainer>
          </>
        ))}
    </FlexColumn>
  );
};

const getFutureMatchIds = (matchId: string, segment: BracketSegment) => {
  const bracket = segment.groups.find((g) =>
    getBracketMatchIds(g).includes(matchId)
  );
  if (!bracket) {
    return [];
  }

  if (!bracket.graph) {
    return [];
  }

  const futureMatchIds: string[] = [];
  const graph = bracket.graph as BracketGraph;
  const nodes = getAllNodes(graph.finalNodes);
  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i];
    const childrenAndSelf = getAllNodes([node]);
    if (
      childrenAndSelf.some(
        (n) =>
          n.match.teamOneSource === matchId || n.match.teamTwoSource === matchId
      )
    ) {
      futureMatchIds.push(node.match.matchId);
    }
  }

  return futureMatchIds.filter(onlyUnique);
};
